// Configuration des variables d'environnement pour Smart LabStock Frontend
import { resolveApiUrl } from '../services/resolveApiUrl.js'

// Variables d'environnement Vite (préfixées par VITE_)
export const env = {
    // Informations de l'application
    APP_NAME: import.meta.env.VITE_APP_NAME || 'Smart LabStock',
    APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
    APP_DESCRIPTION: import.meta.env.VITE_APP_DESCRIPTION || 'Gestion intelligente des stocks de laboratoire',
    APP_ENV: import.meta.env.VITE_APP_ENV || 'development',

    // Configuration API — résolue au runtime selon le hostname
    get API_BASE_URL() { return `${resolveApiUrl()}/api` },
    API_TIMEOUT: parseInt(
        import.meta.env.VITE_API_TIMEOUT) || 10000,
    get WS_URL() { return resolveApiUrl() },

    // Configuration de l'application
    DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true',

    // Pagination
    DEFAULT_PAGE_SIZE: parseInt(
        import.meta.env.VITE_DEFAULT_PAGE_SIZE) || 20,
    MAX_PAGE_SIZE: parseInt(
        import.meta.env.VITE_MAX_PAGE_SIZE) || 100,

    // Upload de fichiers
    MAX_FILE_SIZE: parseInt(
        import.meta.env.VITE_MAX_FILE_SIZE) || 10485760, // 10MB
    ALLOWED_FILE_TYPES: import.meta.env.VITE_ALLOWED_FILE_TYPES || 'image/*,.pdf,.xlsx,.csv',

    // Thème
    DEFAULT_THEME: import.meta.env.VITE_DEFAULT_THEME || 'light',
    ENABLE_DARK_MODE: import.meta.env.VITE_ENABLE_DARK_MODE === 'true',

    // Analytics et monitoring
    ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',

    // Performance
    ENABLE_PWA: import.meta.env.VITE_ENABLE_PWA === 'true',
    CACHE_DURATION: parseInt(
        import.meta.env.VITE_CACHE_DURATION) || 3600000, // 1 heure

    // Variables de build (définies dans vite.config.js)
    BUILD_VERSION: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '1.0.0',
    BUILD_TIME: typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : new Date().toISOString(),

    // Mode de développement
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
}

// Log de configuration en mode développement
if (env.DEBUG_MODE && env.isDevelopment) {
    console.log('🔧 Smart LabStock Configuration:', {
        environment: env.APP_ENV,
        apiUrl: env.API_BASE_URL,
        wsUrl: env.WS_URL,
        version: env.BUILD_VERSION,
        buildTime: env.BUILD_TIME
    })
}

export default env